<!--工作室咨询、成果等详情-->
<template>
    <div class="info-top-title">
        <div class="title">{{infoTitle}}</div>
    </div>
    <div class="detail-container">
        <div class="detail-title">{{ info.title }}</div>
        <div class="detail-time-read">
            <div class="detail-time">发布时间：{{ timestampToTime(info.createTime)}}</div>
            <div class="detail-read">阅读数：{{info.readNum }}</div>

        </div>
        <div v-html="info.appContent"></div>

        <div class="detail-file" v-if="info.fileList && info.fileList.length !== 0">
            <div class="detail-file-tag">
                <div>附件</div>
            </div>
            <div class="detail-file-list">
                <div class="file-item" v-for="item in info.fileList" :key="item">
                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                    <div class="file-view">
                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                  :src="require('@/assets/file/file_view_color.png')"
                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                        </el-image>
                    </div>
                    <div class="file-view" @click="downloadFile(item)">
                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {studioInfo, studioRead} from "@/api/admin/studio";
import {timestampToTime} from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";

export default {
    name:'viewInfo',
    components:{

    },
    props:{
        infoId:{
            type: String,
            default:null
        },
        infoTitle:{
            type: String,
            default:"详情"
        },
    },
    watch:{
        infoId(newValue,oldValue){
            this.viewInfo()
        }
    },
    mounted() {
        this.viewInfo()
    },
    data() {
        return {
            timestampToTime,
            showMode:'detail',
            info:{},
        }
    },
    methods: {
        viewInfo(){
            if (this.infoId!==null&&this.infoId!==undefined&&this.infoId!==''){
                studioInfo({ infoId: this.infoId }).then(res => {
                    if (res.data.code === 1) {
                        this.info = res.data.data;
                        studioRead({ infoId: this.infoId }).then(res => {})
                    }else {
                        this.$message.error("请求出错")
                    }

                })
            }

        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {

            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
    }
}

</script>

<style scoped>
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 34px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    color: #3b62f8;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #3b62f8;
}
.detail-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    color: #333333;
    font-size: 16px!important;
}
.detail-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
}
.detail-time-read{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    color: #c2c0c0;
    display: flex;
}
.detail-time{
    width: 50%;
    padding-right: 40px;
    text-align: right;
    box-sizing: border-box;
}
.detail-read{
    width: 50%;
    padding-left: 40px;
    text-align: left;
    box-sizing: border-box;
}
.detail-file{
    width: 100%;
    height: auto;
    line-height: 36px;
    display: flex;
}
.detail-file-tag{
    width: 80px;
    height: auto;
    div{
        width: 60px;
        height: 28px;
        line-height: 28px;
        background-color: #3b62f8;
        color: #fff;
        text-align: center;
        margin: auto;
        border-radius: 5px;
        font-size: 14px;
    }
}
.detail-file-list{
    width: calc(100% - 80px);
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 90%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #3b62f8!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 100px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
}
.file-view{
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        cursor: pointer;
    }
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 22px;
    height: 22px;
    cursor: pointer;
}
</style>